import React, { useState, useEffect } from "react";

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Button,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import { functions } from "../config/firebase";
import FirebaseProvider from "../api/firebaseProvider";
import { routes } from "../constants/routes";
import ProblemsSubmitting from "./ProblemsSubmitting";

const SubmitProjectPopover = ({ scratchathonID, lgBtn }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const [projectID, setProjectID] = useState("");
  const toast = useToast();

  const openPopover = () => setIsPopoverOpen(!isPopoverOpen);
  const closePopover = () => setIsPopoverOpen(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitLoading(true);

    try {
      const data = {
        eventID: scratchathonID,
        projectID,
      };

      console.log(data);

      let r = await functions.httpsCallable("addProject")(data);
      // await FirebaseProvider.addNewProject(scratchathonID, projectID);
      console.log(r);
      toast({
        title: "Project submitted!",
        description:
          "Your project has been submitted to this event. Please refresh.",
        status: "success",
      });

      closePopover();
    } catch (e) {
      // alert("asdf");
      console.log(e, e.type, e.status, e.message);
      switch (e.message) {
        case "project-not-found":
          toast({
            title: "Project not found.",
            description:
              "We couldn't find a project with that ID. Please make sure you have entered the right ID.",
            status: "error",
          });

          break;
        case "project-already-submitted":
          toast({
            title: "Project already submitted.",
            description:
              "Your project has already been submitted. Please contact us if this is an error.",
            status: "warning",
          });

          break;
        default:
          break;
      }
    }

    setIsSubmitLoading(false);
  };

  return (
    <Popover isOpen={isPopoverOpen} onClose={closePopover}>
      <PopoverTrigger>
        <button
          href=""
          className={`bg-blue-500 hover:bg-blue-400 transition-colors duration-150 text-white rounded-md w-full md:w-auto ${
            lgBtn ? "px-8 py-3 font-semibold" : "px-4 py-2 font-medium"
          }`}
          onClick={openPopover}
        >
          Submit a project
        </button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverBody>
          <form className="space-y-2 p-1" onSubmit={handleSubmit}>
            <input
              type="text"
              className="input"
              placeholder="Project ID"
              value={projectID}
              required
              onChange={(e) => setProjectID(e.target.value)}
            />

            <button
              className="flex justify-center btn-md bg-blue-500 transition-colors hover:bg-blue-400 shadow-inner` text-white focus:bg-blue-400 focus:ring-4 ring-blue-200 w-full text-sm"
              type="submit"
            >
              {isSubmitLoading ? <Spinner size="sm" /> : "Submit"}
            </button>
          </form>
          <div className="mt-3 space-y-px">
            <a
              href={routes.external.findProjectID}
              className="cursor-pointer flex justify-end text-xs text-gray-400 hover:underline font-medium"
            >
              How do I find my project ID?
            </a>
            <ProblemsSubmitting />
          </div>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default SubmitProjectPopover;
